"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Menu;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../../utils/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MenuList = _styledComponents["default"].div.withConfig({
  displayName: "Menu__MenuList",
  componentId: "k2yojz-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;flex-flow:column nowrap;justify-content:stretch;position:absolute;background-color:", ";border-radius:0.25rem;padding:0 1rem;opacity:0;transform-origin:top;transform:scaleY(0);overflow:hidden;transition:all 0.2s ease-in-out;box-shadow:", " 0 ", " ", ";", " > * + *{margin-top:0.5rem;}"], props.theme.color.panel, props.theme.globalSizes.small, props.theme.globalSizes.xl, props.theme.color.structure, props.visible && (0, _styledComponents.css)(["transform:scaleY(1);padding:1rem;opacity:1;"]));
});
/**
 * Pop up menu component
 *
 * The `Menu` component currently achors to the bottom of another component/element allowing the available options to expand downwards. The options should be a set of child `Button` components.
 *
 * Note: This has currrently only been designed to work with the `NavbarHeader` component.
 */


function Menu(_ref) {
  var children = _ref.children,
      anchorRef = _ref.anchorRef,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;

  var _React$useState = _react["default"].useState({
    top: 0,
    left: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      menuStyle = _React$useState2[0],
      setMenuStyle = _React$useState2[1];

  var closeDebounce = _react["default"].useRef();

  var menuRef = _react["default"].useRef();

  function handleMouseUp(event) {
    closeDebounce.current = clearTimeout();

    if (event.target !== menuRef.current) {
      closeDebounce.current = setTimeout(function () {
        if (visible) {
          onClose(event);
        }
      }, 100);
    }
  }

  _react["default"].useLayoutEffect(function () {
    if (!anchorRef.current) return;

    var _anchorRef$current$ge = anchorRef.current.getBoundingClientRect(),
        top = _anchorRef$current$ge.top,
        left = _anchorRef$current$ge.left,
        height = _anchorRef$current$ge.height;

    setMenuStyle({
      top: top + height,
      left: left
    });
  }, [visible]);

  _react["default"].useEffect(function () {
    if (visible) {
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mouseup', handleMouseUp);
    }

    return function unMount() {
      window.removeEventListener('mouseup', handleMouseUp);
      closeDebounce.current = clearTimeout();
    };
  }, [visible]);

  return /*#__PURE__*/_react["default"].createElement(MenuList, {
    visible: visible,
    "aria-hidden": !visible,
    "aria-expanded": visible,
    role: "list",
    style: menuStyle,
    ref: menuRef
  }, (0, _utils.clonePropsToChildren)(children, {
    tabIndex: visible ? '0' : '-1'
  }));
}